<div class="container-fluid">
   <div class="row">
      <div class="col d-flex justify-content-center">
         <div class="int col-12 d-flex flex-column">
            <div class="int-title d-flex mt-5 ml-3 align-items-center w-100">
               <div class="d-flex col-3 justify-content-center pl-0 align-self-start">
                  <button class="int-btn btn btn-outline-info text-dark btn-sm mr-3" routerLink="/public/landing-page">
                     <i class="bi bi-arrow-left-short"></i>{{ 'buttons.back' | translate | titlecase }}
                  </button>
               </div>
               <div class="title-btn w-50 text-center col-5 col-xl-9">
                  <h5 class="h5 mr-3 col-12 col-xl-8 w-100">{{ 'public.integrated-sp.title' | translate }}</h5>
               </div>
            </div>

            <div class="int-data d-flex justify-content-center">
               <div class="int-data__container">
                  <div class="int-data__sp d-flex flex-column justify-content-around align-items-center h-100">
                     <h5 class="int-data__sp--title">{{ 'public.integrated-sp.title-sp' | translate }}</h5>
                     <!-- <div class="int-data__sp--img">
                        <img src="./../../../assets/images/integrated-service-providers/banc.svg" alt="Banc" />
                     </div> -->
                     <div class="int-data__sp--desc d-flex flex-column justify-content-between align-self-start">
                        <div class="desc">
                           <img
                              src="./../../../assets/images/integrated-service-providers/lists.svg"
                              class="mr-3"
                              alt="Lists"
                           />
                           <a href="https://asp.gov.md/" target="_blank" rel="noopener">{{
                              'public.integrated-sp.title-agency' | translate
                           }}</a>
                        </div>
                        <ul>
                           <li>
                              <a href="https://servicii.gov.md/ro/service/003001389" target="_blank" rel="noopener">
                                 {{ 'public.integrated-sp.agency-info' | translate }}
                              </a>
                           </li>
                           <li>
                              <a href="https://servicii.gov.md/ro/service/015000448" target="_blank" rel="noopener">
                                 {{ 'public.integrated-sp.passport-info' | translate }}
                              </a>
                           </li>
                           <li>
                              <a href="https://servicii.gov.md/ro/service/008000383" target="_blank" rel="noopener">
                                 {{ 'public.integrated-sp.international-driving-licence' | translate }}
                              </a>
                           </li>
                           <li>
                              <a href="https://servicii.gov.md/ro/service/008000736" target="_blank" rel="noopener">
                                 {{ 'public.integrated-sp.registration-certificate' | translate }}
                              </a>
                           </li>
                           <li>
                              <a href="https://servicii.gov.md/ro/service/015000134" target="_blank" rel="noopener">
                                 {{ 'public.integrated-sp.civil-status-certificate' | translate }}
                              </a>
                           </li>
                           <li>
                              <a href="https://servicii.gov.md/ro/service/012000128" target="_blank" rel="noopener">
                                 {{ 'public.integrated-sp.cadastral-document' | translate }}
                              </a>
                           </li>
                           <li>
                              <a
                                 href="https://www.asp.gov.md/ro/servicii/persoane-fizice/15/155/dn"
                                 target="_blank"
                                 rel="noopener"
                              >
                                 {{ 'public.integrated-sp.child-passport' | translate }}
                              </a>
                           </li>
                           <li>
                              <a href="https://servicii.gov.md/ro/service/015000163" target="_blank" rel="noopener">
                                 {{ 'public.integrated-sp.identity-card-document' | translate }}
                              </a>
                           </li>
                        </ul>
                     </div>
                     <div class="int-data__sp--desc d-flex flex-column justify-content-between align-self-start">
                        <div class="desc">
                           <img
                              src="./../../../assets/images/integrated-service-providers/lists.svg"
                              class="mr-3"
                              alt="Lists"
                           />
                           <a href="https://mai.gov.md/" target="_blank" rel="noopener">{{
                              'public.integrated-sp.title-mai' | translate
                           }}</a>
                        </div>
                        <ul>
                           <li>
                              <a href="https://servicii.gov.md/ro/service/021000337" target="_blank" rel="noopener">
                                 {{ 'public.integrated-sp.record-info' | translate }}
                              </a>
                           </li>
                        </ul>
                     </div>
                     <div class="int-data__sp--desc d-flex flex-column justify-content-between align-self-start">
                        <div class="desc">
                           <img
                              src="./../../../assets/images/integrated-service-providers/lists.svg"
                              class="mr-3"
                              alt="Lists"
                           />
                           <a href="https://anta.gov.md/" target="_blank" rel="noopener">{{
                              'public.integrated-sp.title-anta' | translate
                           }}</a>
                        </div>
                        <ul>
                           <li>
                              <a href="https://eat.anta.gov.md/?s=ACEMT#Service" target="_blank" rel="noopener">
                                 {{ 'public.integrated-sp.cemt-permits' | translate }}
                              </a>
                           </li>
                           <li>
                              <a href="https://eat.anta.gov.md/?s=ABSEC#Service" target="_blank" rel="noopener">
                                 {{ 'public.integrated-sp.bsec-permits' | translate }}
                              </a>
                           </li>
                           <li>
                              <a href="https://eat.anta.gov.md/?s=AT#Service" target="_blank" rel="noopener">
                                 {{ 'public.integrated-sp.traceca-permits' | translate }}
                              </a>
                           </li>
                           <li>
                              <a href="https://eat.anta.gov.md/?s=CFDPTC#Service" target="_blank" rel="noopener">
                                 {{ 'public.integrated-sp.cfp-roadmap-logbook' | translate }}
                              </a>
                           </li>
                           <li>
                              <a href="https://eat.anta.gov.md/?s=CFDPI#Service" target="_blank" rel="noopener">
                                 {{ 'public.integrated-sp.interbus-roadmap-logbook' | translate }}
                              </a>
                           </li>
                           <li>
                              <a
                                 href="https://servicii.gov.md/ro/search?term=Autoriza%C8%9Bie%20de%20transport%20rutier%20&size=50"
                                 target="_blank"
                                 rel="noopener"
                              >
                                 {{ 'public.integrated-sp.international-road-transport-permits' | translate }}
                              </a>
                           </li>
                           <li>
                              <a href="https://eat.anta.gov.md/?s=AP#Service" target="_blank" rel="noopener">
                                 {{ 'public.integrated-sp.commuting-permits' | translate }}
                              </a>
                           </li>
                           <li>
                              <a href="https://eat.anta.gov.md/?s=AACEMT#Service" target="_blank" rel="noopener">
                                 {{ 'public.integrated-sp.short-term-cemt-permit-activation' | translate }}
                              </a>
                           </li>
                        </ul>
                     </div>
                     <div class="int-data__sp--desc d-flex flex-column justify-content-between align-self-start">
                        <div class="desc">
                           <img
                              src="./../../../assets/images/integrated-service-providers/lists.svg"
                              class="mr-3"
                              alt="Lists"
                           />
                           <a href="https://arhiva.gov.md/" target="_blank" rel="noopener">{{
                              'public.integrated-sp.title-archive' | translate
                           }}</a>
                        </div>
                        <ul>
                           <li>
                              <a href="https://servicii.gov.md/ro/service/002000345" target="_blank" rel="noopener">
                                 {{ 'public.integrated-sp.archive-certificates' | translate }}
                              </a>
                           </li>
                        </ul>
                     </div>
                     <!--  <div class="int-data__sp--inf d-flex align-self-start">
                        <span class="mr-3"><i class="bi bi-exclamation-circle"></i></span>
                        <p>{{ 'public.integrated-sp.exclamation-sp' | translate }}</p>
                     </div> -->
                  </div>
               </div>

               <div class="int-data__container">
                  <div class="int-data__carrier d-flex flex-column justify-content-around align-items-center h-100">
                     <h5 class="int-data__carrier--title">{{ 'public.integrated-sp.title-carrier' | translate }}</h5>

                     <!--   <div class="int-data__carrier--img d-flex justify-content-center">
                        <img src="./../../../assets/images/integrated-service-providers/letter.svg" alt="Letter" />
                     </div> -->
                     <div class="int-data__carrier--logo">
                        <a href="https://www.posta.md/" target="_blank" rel="noopener" title="Posta">
                           <img src="./../../../assets/images/integrated-service-providers/posta.svg" alt="Posta" />
                        </a>
                        <a href="https://www.fancourier.md/" target="_blank" rel="noopener" title="FanCourier">
                           <img src="./../../../assets/images/integrated-service-providers/fan.svg" alt="FanCourier" />
                        </a>
                        <a href="https://dhl.md/" target="_blank" rel="noopener" title="DHL">
                           <img src="./../../../assets/images/integrated-service-providers/dhl.svg" alt="DHL" />
                        </a>
                        <a href="https://novaposhta.md/" target="_blank" rel="noopener" title="NovaPoshta">
                           <img src="./../../../assets/images/integrated-service-providers/npg.svg" alt="NovaPoshta" />
                        </a>
                        <a
                           href="https://www.fedex.com/ro-md/home.html"
                           target="_blank"
                           rel="noopener"
                           title="FedExExpress"
                        >
                           <img
                              src="./../../../assets/images/integrated-service-providers/fedex.svg"
                              alt="FedExExpress"
                           />
                        </a>
                        <a href="https://mentor-express.com/ro/" target="_blank" rel="noopener" title="MentorExpress">
                           <img
                              src="./../../../assets/images/integrated-service-providers/mentor.svg"
                              alt="MentorExpress"
                           />
                        </a>
                     </div>
                     <div class="int-data__carrier--inf d-flex align-self-start">
                        <span class="mr-3"><i class="bi bi-exclamation-circle"></i></span>
                        <p>{{ 'public.integrated-sp.exclamation-carrier' | translate }}</p>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</div>
